const { UTM_CONTENT_PARAMETER } = require('../constants/ProfileConstants');

function getUtmContent() {
    if (typeof window === 'undefined') return null;

    const utmContent = new URLSearchParams(window.location.search).get(UTM_CONTENT_PARAMETER);
    if (utmContent) {
        try {
            window.sessionStorage.setItem(UTM_CONTENT_PARAMETER, utmContent);
        } catch (e) {
            // Ignore unavailable sessionStorage; this request still carries the URL value.
        }
        return utmContent;
    }

    try {
        return window.sessionStorage.getItem(UTM_CONTENT_PARAMETER);
    } catch (e) {
        return null;
    }
}

function addUtmContentToUrl(url) {
    const utmContent = getUtmContent();
    if (!utmContent || !url) return url;

    try {
        const isAbsoluteUrl = /^[a-z][a-z\d+\-.]*:/i.test(url);
        const parsedUrl = new URL(url, window.location.origin);
        if (!parsedUrl.searchParams.has(UTM_CONTENT_PARAMETER)) {
            parsedUrl.searchParams.set(UTM_CONTENT_PARAMETER, utmContent);
        }

        return isAbsoluteUrl ? parsedUrl.toString() : `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
    } catch (e) {
        return url;
    }
}

module.exports = {
    getUtmContent,
    addUtmContentToUrl,
};
